import { company_name } from "@/i18n/variables";

const debtors = {
	add_button: "Schuldner hinzufügen",
	add_debtor: {
		form: {
			common_email_address: {
				label: "Allgemeine E-Mail-Adresse",
				placeholder: `info@${company_name}.nl`,
			},
			company_address_description:
				"In diesem Abschnitt können Sie die Adressdetails des zu erstellenden Unternehmens ausfüllen.",
			/* ---------------------------- ADRESSDETAILS DES UNTERNEHMENS -------------------------- */
			company_address_title: "Adressdetails",
			company_communication_description:
				"In diesem Abschnitt können Sie die Kommunikationspräferenzen des zu erstellenden Unternehmens ausfüllen.",
			/* ------------------------- FIRMENKOMMUNIKATIONSDATEN ---------------------- */
			company_communication_title: "Kommunikationspräferenzen",
			company_info_description:
				"In diesem Abschnitt können Sie eine Firma zum Schuldner hinzufügen.",
			/* ------------------------------ FIRMENINFORMATIONEN ------------------------------ */
			company_info_title: "Firma hinzufügen",
			company_invoice_description:
				"In diesem Abschnitt können Sie die Rechnungsdetails des zu erstellenden Unternehmens ausfüllen.",
			/* ---------------------------- RECHNUNGSDETAILS DES UNTERNEHMENS -------------------------- */
			company_invoice_title: "Rechnungsdetails",
			debtor_account_description:
				"Hier können Sie vorhandene Benutzer einem Schuldner hinzufügen oder einen neuen Benutzer einladen und ihn direkt hinzufügen.",
			/* ------------------------------- BENUTZER HINZUFÜGEN ------------------------------ */
			debtor_account_title: "Benutzer hinzufügen",
			debtor_groups: {
				label: "Schuldnergruppen",
				placeholder: "Wiederverkäufer",
			},
			debtor_info_description: "Schuldnerinformation",
			/* ------------------------------- SCHULDNER INFORMATION ------------------------------ */
			debtor_info_title: "Schuldnerinformation",
			debtor_name: {
				label: "Schuldnername",
				placeholder: `${company_name}`,
			},
			debtor_type: {
				business: "Geschäftlich",
				label: "Typ",
				placeholder: "Geschäftlich",
				private: "Privat",
			},
			different_invoice: {
				label: "Unterschiedliche Rechnungsdetails?",
				no: "Nein",
				yes: "Ja",
			},
			email_address: {
				label: "E-Mail-Adresse",
				placeholder: `info@${company_name}.nl`,
			},
			emergency_number: {
				label: "Notrufnummer",
				placeholder: "0612345678",
			},
			internal_note: {
				label: "Interne Notiz",
				placeholder: "Interne Notiz",
			},
			invoices_email_address: {
				label: "Rechnungs-E-Mail-Adresse",
				placeholder: `administratie@${company_name}.nl`,
			},
			kvk_number: {
				label: "Handelsregisternummer",
				placeholder: "12345678",
			},
			never_invoice: {
				description: "Diesen Schuldner niemals fakturieren",
				label: "Nie fakturieren",
			},
			paid_services_disabled: {
				description: "Bezahlte Dienste ausschließen",
				label: "Bezahlte Dienste",
			},
			username: {
				label: "Benutzername",
				placeholder: `${company_name}`,
			},
		},
		title: "Schuldner hinzufügen",
	},
	edit_debtor: {
		form: {
			company_address_description:
				"In diesem Abschnitt können Sie die Rechnungsdetails der Firma bearbeiten.",
			company_communication_description:
				"In diesem Abschnitt können Sie die Adressdetails der Firma bearbeiten.",
			company_info_description:
				"In diesem Abschnitt können Sie die Firma des Schuldners bearbeiten.",
			company_info_title: "Firma bearbeiten",
			company_invoice_description:
				"In diesem Abschnitt können Sie die Rechnungsdetails der Firma bearbeiten.",
		},
		title: "Schuldner bearbeiten",
	},
	import_button: "Schuldner importieren",
	membership_type: {
		business: "Business",
		label: "Wähle Schuldnertyp",
		private: "Private",
	},
	table: {
		company: "Firma",
		debtor_code: "Schuldnernummer",
		details: "Details",
		family_name: "Nachname",
		given_name: "Vorname",
		middle_name: "Mittlerer Name",
		name: "Name",
		type: "Typ",
	},
	title: "Schuldner",
};

export default debtors;
